<template>
    <div v-if="isShow" :class="{backdrop: blur ,'is-backdrop-show':blur && isShow}">
        <div :class="{'swipe-tip-menu': true, 'is-show': isShow}"
             v-touch="{
                down: ()=> $emit('close')
            }"
             @touchstart.stop
             @touchmove.stop
        >
            <v-row justify="center" class="pt-6">
                <div class="control-line"></div>
                <app-icon class="close-button close black--text" icon="close" @click="$emit('close')"></app-icon>
            </v-row>
            <v-row align="center" justify="center" no-gutters class="mt-6">
                <v-col cols="2" v-for="(item, i) in tips " :key="i" class="mr-4">
                    <div @click="activeTip = i; model.tip=item;" :class="{'select-tip': true, active: i === activeTip}">
                        {{ formatPrice(item) }}
                    </div>
                </v-col>
                <v-col cols="3">
                    <v-text-field
                        @click="model.tip = inputTip; activeTip = -1;"
                        @input="model.tip = inputTip"
                        filled
                        hide-details
                        outlined
                        dense
                        solo
                        solo-inverted
                        background-color="rgba(237,237,237,.53)"
                        color="black"
                        :suffix="currency"
                        v-mask="`###`"
                        v-model="inputTip"
                        black-text
                        text-center
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row class="mt-4">
                <v-col>
                    <v-textarea
                        filled
                        hide-details
                        outlined
                        dense
                        solo
                        solo-inverted
                        background-color="rgba(237,237,237,.53)"
                        color="black"
                        v-model="model.text"
                        black-text
                        rows="2"
                        no-resize
                        :placeholder="$t('components.tip_menu.your_message') "
                        class="mr-6 ml-6 border"
                    ></v-textarea>
                </v-col>
            </v-row>
            <v-row justify="center" class="fill-width">
                <v-col class="pl-1 pr-10">
                    <gradient-button style="color: white" block @click="save"
                                     :loading="$store.getters.loadingBtn(['setting', 'tipSendBtn']) || loading"
                    >{{ this.$t('components.tip_menu.send_button') }}
                    </gradient-button>
                </v-col>
            </v-row>
        </div>
        <verify-dialog
            v-if="isShowVerifyDialog"
            @close="handleCloseVerifyDialog"
        />
        <inform-dialog
            v-if="isShowCantSendFunds"
            :text="$t('dialogs.send_funds', {username: targetUsername})"
            @close="handleCloseCantSendFunds"
        />
    </div>
</template>

<script>
import Radio from "@/components/app/form/Radio";
import GradientButton from "@/components/app/button/GradientButton";
import {CURRENCY_SYMBOL} from "@/configs/constants";
import VerifyDialog from "@/components/app/dialogs/VerifyDialog";
import InformDialog from "@/components/app/dialogs/InformDialog";
import {mapState} from "vuex";

export default {
    name: "SwipeTipMenu",
    data: () => ({
        model: {
            radio: 'send',
            tip: 10,
            text: '',
        },
        tips: [5, 10, 15],
        inputTip: '',
        activeTip: 1,
        hidden: true,
        isShowVerifyDialog: false,
        isShowCantSendFunds: false,
        currency: CURRENCY_SYMBOL,
    }),
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
        hasRadio: {
            type: Boolean,
            default: true
        },
        blur: {
            type: Boolean,
            default: false
        },
        loading: {
            default: false
        },
        targetVerified: {
            type: Boolean,
        },
        targetUsername: {
            type: String,
        },
    },
    computed: {
        ...mapState({
            verified: state => state.user.user.data.verified
        }),
        canRequest() {
            return this.verified
        },
        currentTip() {
            return this.tips[this.activeTip];
        }
    },
    methods: {
        save() {
            if (!this.targetVerified) {
                this.isShowCantSendFunds = true
                return
            }
            this.$emit('save', this.model)
            this.model = {
                ...{
                    radio: 'send',
                    tip: this.currentTip,
                    text: '',
                },
            }
            this.$emit('close')
        },
        formatPrice(price) {
            return price + this.currency
        },
        handleCloseVerifyDialog() {
            this.isShowVerifyDialog = false
        },
        handleCloseCantSendFunds() {
            this.isShowCantSendFunds = false
            if (!this.targetVerified && !this.canRequest) {
                this.$emit('close')
            }
        },
        onClickRequest() {
            if (!this.canRequest) {
                this.isShowVerifyDialog = true
            }
        },
        onClickSend() {
            if (!this.targetVerified) {
                this.isShowCantSendFunds = true
            }
        },
    },
    watch: {
        isShow(val) {
            if (val && !this.targetVerified) {
                this.model.radio = 'request'
                if (!this.canRequest) {
                    this.isShowCantSendFunds = true
                }
            }
        }
    },
    components: {
        GradientButton,
        Radio,
        VerifyDialog,
        InformDialog,
    },
}
</script>

<style scoped lang="scss">
@import '@/sass/modules/_variables';

.backdrop {
    position: fixed;
    top: 0;
    height: 0;
    left: 0;
    right: 0;
    backdrop-filter: blur(3px);
    transition: 0.3s;
    z-index: 102;
}

.is-backdrop-show {
    height: 100vh;
}

.swipe-tip-menu {
    background: white;
    position: fixed;
    bottom: 0;
    height: 0px;
    border-radius: 30px 30px 0 0;
    width: 100vw;
    color: black !important;
    transition: 0.2s;
    z-index: 100;
}

.swipe-tip-menu.is-show {
    height: 345px;
}

.control-line {
    background: black;
    height: 4px;
    border-radius: 5px;
    width: 40px;
}

.swipe-tip-menu * {
    color: black;
}

.select-tip {
    background: rgba(237, 237, 237, .53);
    border-radius: 6px;
    padding: 9px;
    width: 100%;
    text-align: center;

}

.select-tip.active {
    background-image: $accent-background;
    color: white
}

.border {
    border: 1px solid rgba(65, 65, 69, .3)
}

.close-button {
    position: absolute;
    right: 30px;
    top: 20px;
    font-size: 1em;
    cursor: pointer;

    &:hover {
        color: map-get($orange, 'darken-4') !important;
    }
}

.RadioGroup-wrapper {
    display: flex;
    justify-content: space-between;
    width: 220px;
}
</style>
